import React from 'react';
import Footer from '../components/Footer';

import video1 from '../img/nvid (1).mp4';
import video2 from '../img/nvid (2).mp4';
import video3 from '../img/nvid (3).mp4';

// Import each image statically
import gal1 from '../img/gal (1).jpeg';
import gal2 from '../img/gal (2).jpeg';
import gal3 from '../img/gal (3).jpeg';
import gal4 from '../img/gal (4).jpeg';
import gal5 from '../img/gal (5).jpeg';
import gal6 from '../img/gal (6).jpeg';
import gal7 from '../img/gal (7).jpeg';
import gal8 from '../img/gal (8).jpeg';
import gal9 from '../img/gal (9).jpeg';

import gal11 from '../img/gal (11).jpeg';
import gal12 from '../img/gal (12).jpeg';
import gal13 from '../img/gal (13).jpeg';
import gal14 from '../img/gal (14).jpeg';
import gal15 from '../img/gal (15).jpeg';

import gal16 from '../img/bnk.jpg'
import gal17 from '../img/bnk2.jpg'

const Gallery = () => {
  const eventImages = [gal1, gal2, gal3, gal4, gal5, gal6, gal7, gal8, gal9,  gal11, gal12, gal13, gal14, gal15, gal16, gal17];

  return (
    <>
      <div className="container mt-5">
        <h2 className="text-center mb-4">Gallery</h2>
        <div className="row">
          {/* Render statically imported images */}
          {eventImages.map((image, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <img
                src={image}
                alt={`Gallery Image ${index + 1}`}
                className="gallery-image"
              />
            </div>
          ))}

          {/* Add videos */}
          <div className="col-md-4 mb-4">
            <video className="gallery-video" controls>
              <source src={video1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="col-md-4 mb-4">
            <video className="gallery-video" controls>
              <source src={video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="col-md-4 mb-4">
            <video className="gallery-video" controls>
              <source src={video3} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Gallery;
